import React, { ReactNode } from 'react';
import cx from 'classnames';

export interface ShadedBoxProps {
  className?: string;
  children: ReactNode;
}

export function ShadedBox({ className, children }: ShadedBoxProps) {
  return (
    <div
      className={cx(
        className,
        'block rounded shadow-[0_0_12px_rgba(0,0,0,0.2)] p-4'
      )}
    >
      {children}
    </div>
  );
}
